import { db } from './firebase';
import {
  collection, addDoc, deleteDoc, doc, getDocs, query, orderBy, serverTimestamp,
} from 'firebase/firestore';

export async function getBlockedEntities() {
  const snap = await getDocs(query(collection(db, 'blockedEntities'), orderBy('createdAt', 'desc')));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function addBlockedEntity({ type, value, reason, actorId, actorName }) {
  await addDoc(collection(db, 'blockedEntities'), {
    type,
    value: value.trim().toLowerCase(),
    reason: reason?.trim() || null,
    createdBy: actorId,
    createdByName: actorName,
    createdAt: serverTimestamp(),
  });
}

export async function removeBlockedEntity(id) {
  await deleteDoc(doc(db, 'blockedEntities', id));
}
